
import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { imgStoragePath } from '../../constants'
import { Row, Col } from 'reactstrap';
import { getGlobalCookie, setGlobalCookie } from '../../utils_v2';
export default function DeploymentMessage({ row, margin }) {
    const [deploymentFlag, setDeploymentFlag] = useState(false)
    const [bannerData, setBannerData] = useState(null)
    const getInfo = () => {
        fetch(`https://sparta-aims.ams3.cdn.digitaloceanspaces.com/maintenance_banner/info.json?timestamp=${new Date().getTime()}`)
            .then(res => res.json())
            .then(resp => {
                const dismissed = JSON.parse(getGlobalCookie('showBanner') || '{}')
                if (resp?.for_projects && (resp?.id !== dismissed?.projects || !dismissed?.projects)) {
                    setDeploymentFlag(resp?.for_projects)
                    setBannerData(resp)
                } else {
                    return
                }
            })
            .catch(() => { })
    }

    useEffect(() => {
        getInfo()
        //URL will be called in every 6 hours 
        const interval = setInterval(getInfo, (6 * 60 * 60 * 1000))
        return () => clearInterval(interval)
    }, [])

    const getClientData = () => {
        let oldCookie = JSON.parse(getGlobalCookie('showBanner'))
        let projectsCookie = { projects: bannerData?.id }
        setGlobalCookie('showBanner', JSON.stringify({ ...oldCookie, ...projectsCookie }), 3,'spartaDomain')
    }
    let marginVal = margin
    return (
        <>
            {deploymentFlag && bannerData?
                row ?
                    <Row style={margin ? { marginTop: marginVal } : null}>
                        <Col md="12">
                            <p className="deployment-info">
                                <span>{bannerData?.message || ''}</span>
                                <span >
                                    <img width="13" onClick={() => { setDeploymentFlag(false); getClientData() }} src={imgStoragePath + "toast_cross.png"} alt="Close Icon" />
                                </span>
                            </p>
                        </Col>
                    </Row>:
                    <Grid item sm="12">
                        <p className="deployment-info">
                            <span>{bannerData?.message || ''}</span>
                            <span >
                                <img width="13" onClick={() => { setDeploymentFlag(false); getClientData() }} src={imgStoragePath + "toast_cross.png"} alt="Close Icon" />
                            </span>
                        </p>
                    </Grid>
                :null}
        </>
    )
}